import React from "react";
import { Line, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import { Divider } from "antd";
import PaymentBreakdownChart from "./PaymentBreakdownChart";
import WeeklyRevenueChart from "./WeeklyRevenueChart";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const ChartComponent = ({ chartData }) => {
  // Data for the daily bookings line chart
  const dailyBookingsData = {
    labels: chartData.dailyBookings.map((item) => item.date),
    datasets: [
      {
        label: "Bookings Count",
        data: chartData.dailyBookings.map((item) => item.bookings_count),
        borderColor: "rgba(75,192,192,1)",
        backgroundColor: "rgba(75,192,192,0.2)",
        fill: true,
        tension: 0.4,
      },
    ],
  };

  // Data for the bookings by status pie chart
  const bookingsByStatusData = {
    labels: chartData.bookingsByStatus.map((item) => item.name),
    datasets: [
      {
        data: chartData.bookingsByStatus.map((item) => item.value),
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#4BC0C0",
          "#FF9F40",
        ],
        hoverOffset: 4,
      },
    ],
  };

  return (
    <div>
      <h3>Bookings by Status</h3>
      <Pie
        data={bookingsByStatusData}
        options={{
          responsive: true,
          plugins: { title: { display: true, text: "Bookings by Status" } },
        }}
      />

      <Divider />
      <h3>Daily Bookings</h3>
      <Line
        data={dailyBookingsData}
        options={{
          responsive: true,
          plugins: { title: { display: true, text: "Daily Bookings" } },
        }}
      />
      <Divider />
      <h3>Payment Method Breakdown</h3>
      <PaymentBreakdownChart data={chartData.paymentMethodBreakdown} />
      <Divider />

      <h3>Weekly Revenue</h3>
      <WeeklyRevenueChart data={chartData.weeklyRevenue} />
    </div>
  );
};

export default ChartComponent;
